import {Component, OnDestroy, OnInit} from '@angular/core';
import {ApiService} from '../../../services/api.service';
import {Globals} from '../../../services/globals.service';
import {MockDataService} from '../../../services/mock-data.service';
import {UserService} from '../../../services/user.service';
import {PowercheckerStateService} from '../../../services/powerchecker-state.service';
import {PowerCheckerService} from '../../../services/powerchecker.service';
import {ApplicationService} from '../../../services/application.service';
import {TILE_TYPE, TileService} from '../../../services/tile.service';
import {TrackAnalyticsService} from '../../../services/track-analytics.service';
import {Subscription} from 'rxjs';
import {ConfigurationService} from '../../../configuration.service';

@Component({
    selector: 'app-powerchecker-tile',
    templateUrl: './powerchecker-tile.component.html',
    styleUrls: ['./powerchecker-tile.component.scss'],
    providers: [Globals]
})

export class PowerCheckerTileComponent implements OnInit, OnDestroy {
    private readonly type: TILE_TYPE = TILE_TYPE.POWER_CHECKER;

    plugAttributes = {
        name: '',
        room: ''
    };

    plugName = 'Mein Gerät';
    plugRoom = 'Mein Zimmer';

    state = false;

    subscriptions: Subscription[] = [];

    constructor(private _apiService: ApiService,
                private _globals: Globals,
                private _mockData: MockDataService,
                private _userService: UserService,
                private powercheckerState: PowercheckerStateService,
                private powerchecker: PowerCheckerService,
                private application: ApplicationService,
                private analytics: TrackAnalyticsService,
                private tiles: TileService,
                private configuration: ConfigurationService) {
    }

    ngOnInit() {
        this.initPlugAttributes();
        this.getPlugAttributes();

        // subscribe to external changes
        this._userService.plugAttributesChanged.subscribe(
            (values: any) => {
                this.plugAttributes = values;
                this.plugName = this.plugAttributes.name;
                this.plugRoom = this.plugAttributes.room;
            }
        );

        // subscribe to state changes
        this.powercheckerState.stateChange.subscribe(
            (value) => {
                this.state = value;
            }
        );

        if (this.application.isDemoMode()) {
            this._mockData.getPlugStatus().subscribe(
                (response: any) => {
                    this.state = response.data.on_off === 1;
                }
            );
            return;
        }
        this.initPowerCheckerStateChange();
    }

    ngOnDestroy() {
        for (const s of this.subscriptions) {
            s.unsubscribe();
        }
    }

    onTileClicked(event): void {
        if (event.target.id === 'sliderKnob') {
            return;
        }
        this.detailEntered();
        this.tiles.openDetailView(this.type);
    }

    onTileRemoveClicked(): void {
        this.tiles.setSelected(false, this.type, true);
    }

    /**
     * Initialize the plugs attributes
     */
    private initPlugAttributes(): void {
        this.plugAttributes = this._userService.getPlugAttributes();
        if (this.plugAttributes === null || this.plugAttributes === undefined) {
            this.getPlugAttributes();
            return;
        }

        this.plugName = this.plugAttributes.name;
        this.plugRoom = this.plugAttributes.room;
    }

    private getPlugAttributes(): void {
        if (this.application.isDemoMode()) {
            return;
        }

        const s = this.configuration.getStoredUserSettings().subscribe(
            (result) => {
                if (result.power_checker.name !== '') {
                    this.plugName = result.power_checker.name;
                }
                if (result.power_checker.room !== '') {
                    this.plugRoom = result.power_checker.room;
                }
                this._userService.updatePlugAttributes(result.power_checker);
            },
            (error) => console.log(error),
            () => s.unsubscribe()
        );
    }

    onStateChange(state: boolean): void {
        this.state = state;
        this.powercheckerState.stateChange.next(state);
        if (this.application.isDemoMode()) {
            return;
        }
        this.powerchecker.setState(state ? 1 : 0).subscribe(
            (res) => {
            },
            (error) => console.log(error)
        );
    }

    detailEntered() {
        if (!(this._globals.getFirstDetailsViewed())) {
            this.trackFirstDetailView();
        }
        this._globals.setFirstDetailsViews();
        this.trackDetailsEntered();
    }

    private initPowerCheckerStateChange(): void {
        const s = this.powerchecker.getState().subscribe(
            // const sub = this._apiService.getPlugStatus().subscribe(
            (res) => {
                const value = res.relay.on_off;
                this.state = value === 1;
            },
            (error) => console.log(error)
        );
        this.subscriptions.push(s);
    }

    private trackDetailsEntered(): void {
        this.analytics.trackEvent({
            action: 'dashboard_tile_tapped',
            properties: {
                category: 'Tiles',
                label: 'Tile: PowerChecker'
            }
        });
    }

    private trackFirstDetailView(): void {
        // Erstes aufrufen eines Detail Screens
        this.analytics.trackEvent({
            action: 'first_detail_view',
            properties: {
                category: 'Screens',
                label: 'Screen: Powerchecker-Details'
            }
        });
    }

}
